var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsDropdownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3109 13.978C16.059 14.23 15.6505 14.23 15.3985 13.978L9.83321 8.41272L4.2679 13.978C4.01595 14.23 3.60746 14.23 3.35551 13.978C3.10356 13.7261 3.10356 13.3176 3.35551 13.0656L9.37701 7.04413C9.62897 6.79218 10.0375 6.79218 10.2894 7.04413L16.3109 13.0656C16.5629 13.3176 16.5629 13.7261 16.3109 13.978Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsDropdownArrow);
export default __webpack_public_path__ + "static/media/actions-dropdown-arrow.cd1d923a2db62c2957429bc29530f660.svg";
export { ForwardRef as ReactComponent };